import { createContext } from "react";
import { DataRow } from "../DataRow";

/** The value passed into the `TableRowContext` provider. */
export interface TableRowContextValue {

  /** The row. */
  readonly row: DataRow<object> | null;

  /** Indicates whether the row has child content. */
  readonly hasChildContent: boolean;

  /** Indicates whether the specified row is a sub row. */
  readonly isSubRow: boolean;
}

/**
 * A context which represents a single table row.
 */
export const TableRowContext = createContext<TableRowContextValue>({
  row: null,
  hasChildContent: false,
  isSubRow: false,
});
